import type {PartiallyRequired} from "@wix/devzai-utils-common";
import {hideableValueCreateHidden} from "@wix/devzai-utils-common";
import {
    DoppeActionLayout,
    doppeListActionGetDefaultListSettings,
    doppeListActionGetDefaultSearchListSettings,
    doppeListActionGetItemClickBehaviourDefaultListSettings,
    doppeListActionGetMainDetailsDefaultSettings,
    doppeListActionListItemGetDefaultListItemSettingsMigrationWithOverrides,
    doppeListActionListItemWithCtaButtonsMigration,
    doppeListActionListItemWithSectionsMigration,
    doppeListActionTemplateCtaButtonsSettingsDefaultValuesMigration,
    doppeListActionTemplateSectionsSettingsDefaultValuesMigration
} from "../../client-server-common";




import {DoppeActionTypeMediaGallery} from "./doppe-action-type-media-gallery";

export function doppeActionTypeMediaGalleryResolveListItemSettings(mediaItem: PartiallyRequired<DoppeActionTypeMediaGallery.MediaGalleryListItemSettings, 'id'>) {

    const {
        title = '',
        description = hideableValueCreateHidden(''),
        ribbon = hideableValueCreateHidden(''),
        ...restMediaItem
    } = mediaItem;

    return {
        ...restMediaItem,
        ...doppeListActionListItemGetDefaultListItemSettingsMigrationWithOverrides(mediaItem.id, mediaItem),
        title: title,
        description: description,
        ribbon: ribbon,
        ...doppeListActionListItemWithCtaButtonsMigration(mediaItem, false),
        ...doppeListActionListItemWithSectionsMigration(mediaItem),
    }
}

export function doppeActionTypeMediaGalleryResolveActionSettings(actionSettings: Partial<DoppeActionTypeMediaGallery.ActionSettings>) {
    const {
        listDataItems = [],
        previewShowDescription = true,
        ...restSettings
    } = actionSettings;

    return {
        ...restSettings,
        previewShowDescription: previewShowDescription,
        ...doppeListActionGetMainDetailsDefaultSettings({}, actionSettings),
        ...doppeListActionGetItemClickBehaviourDefaultListSettings(actionSettings),
        ...doppeListActionGetDefaultSearchListSettings(actionSettings),
        ...doppeListActionGetDefaultListSettings<DoppeActionTypeMediaGallery.MediaGalleryListItemSettings>({
            layout: DoppeActionLayout.Carousel,
            ...actionSettings,
            listDataItems: listDataItems.map(doppeActionTypeMediaGalleryResolveListItemSettings),
        }),
        ...doppeListActionTemplateCtaButtonsSettingsDefaultValuesMigration(actionSettings, false),
        ...doppeListActionTemplateSectionsSettingsDefaultValuesMigration(actionSettings),
    } satisfies DoppeActionTypeMediaGallery.ActionSettings;
}